import Pager from '@/shared/pager/pager';

export default {
  build: () => {
    const keysToSearch = [
      'name',
      'category.label',
      'club.name',
    ];

    const exportDefinitions = [
      { value: 'id', label: 'Id' },
      { value: 'name', label: 'Name' },
      { value: 'category.label', label: 'Category' },
      { value: 'club.name', label: 'Club' },
      { value: 'locality', label: 'Locality' },
      { value: 'country', label: 'Country' },
      { value: 'created', label: 'Created at' },
      { value: 'modified', label: 'Updated at' }
    ];

    return new Pager(keysToSearch, exportDefinitions);
  }
};



// WEBPACK FOOTER //
// ./src/entities/tournament/tournament-pager.js